import { render, staticRenderFns } from "./TabViatic.vue?vue&type=template&id=58df5ff6"
import script from "./TabViatic.vue?vue&type=script&lang=js"
export * from "./TabViatic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports